import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import { styled } from '@mui/material/styles'

import IntegrationsTab from './tabs/IntegrationsTab'
import AddManuallyTab from './tabs/AddManuallyTab'
import ImportCsvTab from './tabs/ImportCsvTab'

const TabPanel = props => {
  const { children, value, index, ...other } = props
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  )
}

const StyledTabs = styled(Tabs)({
  borderBottom: '1px solid #e8e8e8',
  '& .MuiTabs-indicator': {
    backgroundColor: '#0246F8'
  }
})

const StyledTab = styled(props => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: {
    minWidth: 0
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  color: 'rgba(0, 0, 0, 0.85)',
  fontFamily: 'Plus Jakarta Sans',
  fontSize: '16px',
  '&.Mui-selected': {
    color: '#0246F8',
    fontWeight: theme.typography.fontWeightMedium
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)'
  }
}))

export default function ImportEmployeesView() {
  const [currentTab, setCurrentTab] = useState(0)

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue)
  }

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <StyledTabs value={currentTab} onChange={handleChangeTab} aria-label='import employees tabs'>
          <StyledTab label='Integrations' />
          <StyledTab label='Add Manually' />
          <StyledTab label='Import CSV' />
        </StyledTabs>
      </Box>
      <TabPanel value={currentTab} index={0}>
        <IntegrationsTab />
      </TabPanel>

      <TabPanel value={currentTab} index={1}>
        <AddManuallyTab />
      </TabPanel>

      <TabPanel value={currentTab} index={2}>
        <ImportCsvTab />
      </TabPanel>
    </Box>
  )
}
